import { ListItemButton } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';
import { WsIconCopy, WsColors, WsIconEmailOutlined } from 'wisestep-base';

import IconTextLink from '../../../../components/IconTextLink';
import { success } from '../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../utils/NotificationStore';
import { useConversationWidgetStore } from '../../../../utils/useConversationWidgetStore';
import { copyStringToClipboard } from '../../../candidateLayout/components/childComponets/CandidateDetailsCard/Helper';
export enum ListType {
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
}

interface IEmailListItem {
  value: string;
  type: ListType;
  setOpenWidget: Dispatch<SetStateAction<boolean>>;
}

const EmailListItem = ({ value, type, setOpenWidget }: IEmailListItem) => {
  const setNotification = useNotificationStore((state) => state.setNotification);
  const updateAction = useConversationWidgetStore((state) => state.updateAction);

  const handleClick = (type: ListType) => {
    switch (type) {
      case 'EMAIL': {
        setOpenWidget(true);
        updateAction('email');
        break;
      }
      case 'PHONE': {
        setOpenWidget(true);
        updateAction('sms');
        break;
      }
    }
  };

  const copy = () => {
    copyStringToClipboard(value);
    setNotification(success('Copied Successfully !!'));
  };
  return (
    <>
      <ListItemButton onClick={() => handleClick(type)}>
        <IconTextLink
          text={type === 'EMAIL' ? 'Send Email' : 'Send SMS'}
          // link={`/jobs/${job.id}/edit`}
          icon={<WsIconEmailOutlined color={WsColors.TertiaryShades900} />}
        />
      </ListItemButton>
      <ListItemButton onClick={copy}>
        <IconTextLink text="Copy" icon={<WsIconCopy color={WsColors.TertiaryShades800} />} />
      </ListItemButton>
    </>
  );
};

export default EmailListItem;
